/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';
import { DxiGroupItemComponent } from './group-item-dxi';
import { DxiTotalItemComponent } from './total-item-dxi';



export class DxoSummaryComponent extends NestedOption {
    
    get calculateCustomSummary(): Function {
        return this._getOption('calculateCustomSummary');
    }
    set calculateCustomSummary(value: Function) {
        this._setOption('calculateCustomSummary', value);
    }

    
    get groupItems(): Array<any|
        { alignByColumn?: boolean, column?: string, customizeText?: Function, displayFormat?: string, name?: string, precision?: number, showInColumn?: string, showInGroupFooter?: boolean, skipEmptyValues?: boolean, summaryType?: string, valueFormat?: DevExpress.ui.format|
        string }> {
        return this._getOption('groupItems');
    }
    set groupItems(value: Array<any|
        { alignByColumn?: boolean, column?: string, customizeText?: Function, displayFormat?: string, name?: string, precision?: number, showInColumn?: string, showInGroupFooter?: boolean, skipEmptyValues?: boolean, summaryType?: string, valueFormat?: DevExpress.ui.format|
        string }>) {
        this._setOption('groupItems', value);
    }

    
    get skipEmptyValues(): boolean {
        return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value: boolean) {
        this._setOption('skipEmptyValues', value);
    }

    
    get texts(): any {
        return this._getOption('texts');
    }
    set texts(value: any) {
        this._setOption('texts', value);
    }

    
    get totalItems(): Array<any|
        { alignment?: string, column?: string, cssClass?: string, customizeText?: Function, displayFormat?: string, name?: string, precision?: number, showInColumn?: string, skipEmptyValues?: boolean, summaryType?: string, valueFormat?: DevExpress.ui.format|
        string }> {
        return this._getOption('totalItems');
    }
    set totalItems(value: Array<any|
        { alignment?: string, column?: string, cssClass?: string, customizeText?: Function, displayFormat?: string, name?: string, precision?: number, showInColumn?: string, skipEmptyValues?: boolean, summaryType?: string, valueFormat?: DevExpress.ui.format|
        string }>) {
        this._setOption('totalItems', value);
    }

    protected get _optionPath() {
        return 'summary';
    }


    
    get groupItemsChildren(): QueryList<DxiGroupItemComponent> {
        return this._getOption('groupItems');
    }
    set groupItemsChildren(value) {
        this.setChildren('groupItems', value);
    }

    
    get totalItemsChildren(): QueryList<DxiTotalItemComponent> {
        return this._getOption('totalItems');
    }
    set totalItemsChildren(value) {
        this.setChildren('totalItems', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-summary',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'calculateCustomSummary': [{ type: Input },],
'groupItems': [{ type: Input },],
'skipEmptyValues': [{ type: Input },],
'texts': [{ type: Input },],
'totalItems': [{ type: Input },],
'groupItemsChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiGroupItemComponent), ] },],
'totalItemsChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiTotalItemComponent), ] },],
};
}


export class DxoSummaryModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoSummaryComponent
  ],
  exports: [
    DxoSummaryComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
